export default "__VITE_PUBLIC_ASSET__4154637a__"